import React, { PropTypes } from 'react';
import { Link } from 'react-router';

const HiddenHomeView = (props) => {

    const dropbox = props.dropbox;

    let semester = props.semesters[dropbox.semester.id];

    return (
        <div className="card" key={dropbox.id}>
            <div className="card-header" role="tab" >
                <h5 className="mb-0">
                    <Link data-toggle="collapse" to={'#collapse'+dropbox.id} aria-expanded="true" aria-controls={'collapse'+dropbox.id}>
                        <i className="fa fa-book" aria-hidden="true"/>&nbsp;
                        {dropbox.name}
                        <span className="float-right">
                            <span>
                                {semester.season}
                            </span>
                            -
                            <span>
                                {semester.year}
                            </span>
                        </span>
                    </Link>
                </h5>
            </div>
            <div
                id={'collapse'+dropbox.id}
                className={parseInt(props.expanded) === parseInt(dropbox.id) ? 'show': 'collapse'}
                role="tabpanel"
                aria-labelledby={'heading'+dropbox.id}
            >
                <div className="card-block">
                    <h5>Please view your course page for assignment links.</h5>
                </div>
            </div>
        </div>
    );

};

HiddenHomeView.propTypes = {
    dropbox: PropTypes.object.isRequired,
    expanded: PropTypes.string,
    semesters: PropTypes.object.isRequired,
};

export default HiddenHomeView;



/** WEBPACK FOOTER **
 ** ./src/components/HiddenHomeView.js
 **/